export default __webpack_public_path__ + "static/media/rightchevron.4cc4e84e.svg";